/**
 * FrequencyToggle
 *
 * Two-option toggle (monthly/annual) with loading-disabled state and optional
 * badges per option.
 */
import React from 'react';

export default function FrequencyToggle({ frequency, setFrequency, isLoading, frequencies }) {
  return (
    <div className="flex justify-center">
      <div className="grid grid-cols-2 gap-x-1 rounded-full p-1 text-center text-xs font-semibold leading-5 ring-1 ring-inset ring-gray-200 dark:ring-gray-700 bg-white/5 backdrop-blur-sm">
        {frequencies.map((option) => (
          <button
            key={option.value}
            onClick={() => !isLoading && setFrequency(option)}
            disabled={isLoading}
            className={`${
              option === frequency
                ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-sm'
                : 'text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800/50'
            } cursor-pointer rounded-full px-6 py-2 font-medium transition-all duration-200 relative ${
              isLoading ? 'opacity-60 cursor-not-allowed' : ''
            }`}
          >
            {option.label}
            {option.badge && (
              <span className="ml-2 text-xs bg-gradient-to-r from-purple-500 to-pink-500 text-white px-2 py-0.5 rounded-full font-bold">
                {option.badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}